import React from 'react';

import { Button } from '@change/ds-core-ui';

import { useFooterLink } from './hooks/useFooterLink';

export function FooterLink(): React.JSX.Element {
	const {
		data: { link, text },
		actions: { onClick },
	} = useFooterLink();

	return (
		<Button
			as="a"
			variant="tertiary"
			data-qa="footer-link"
			onClick={onClick}
			href={link}
			tabIndex={0} // see accessibility.md
		>
			{text}
		</Button>
	);
}
